<template>
  <div class="Empower">
    <button @click="authorize">点击授权</button>
	 
	 
  </div>
</template>

<script>
import axios from 'axios';

export default {
  methods: {
    authorize() {
      // 构造微信授权URL
      const redirectUri = 'https://gzhweb.tozo.com.cn/reward'; // 回调URL
      const appId = 'wx5457e1434cfcba03'; // AppID
      const scope = 'snsapi_base'; // 基础授权，只获取openid
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`;

      // 跳转到微信授权页面
      window.location.href = authUrl;
    },
    async getOpenid(code) {
      // 使用code换取openid的接口URL
      const appId = 'wx5457e1434cfcba03'; // AppID
      const appSecret = '3f243a13177b3ce856ccabc31c7fff45'; // AppSecret
      const url = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appId}&secret=${appSecret}&code=${code}&grant_type=authorization_code`;

      try {
        const response = await axios.get(url);
        const openid = response.data.openid;
        console.log('openid:', openid);
		  localStorage.setItem('openid', openid)
        // 在这里可以将openid保存到Vue组件的data中，或者进行其他操作
      } catch (error) {
        console.error('获取openid失败:', error);
      }
    }
  },
  mounted() {
    // 获取URL中的code参数
    const code = new URLSearchParams(window.location.search).get('code');
    if (code) {
      // 获取到code，调用接口获取openid
      this.getOpenid(code);
    }
  }
};
</script>
<style lang='less' scoped>
	.Empower{
		color: #ffffff;
	}
</style>